export const profileFragment = () => `
    fragment Profile on UserProfile {
        firstname
        lastname
        gender
        ageRange
        height
        weight
        diets {
            id
            name
            description
            image
        }
        tastes {
            id
            name
        }
        favorites: mealWishes {
            mealId
            profileId
        }
        avoids: mealAvoids {
            mealId
            profileId
        }
        goals {
            id
            name
        }
        restrictions {
            id
        }
    }
`;

export const userDataFragment = () => `
    fragment UserData on User {
        id
        store_id
        email
        status
        plan_id
        plan_variety
        plan_comments
        deliveryDays {
          id
          day
          time_start
          time_end
        }
        ring {
            id
            is_local
        }
    }
`;

export const planFragment = () => `
    fragment Plan on Plan {
        id
        sidedishes
        price
        deliveryFee
        discountPrice
        mealsPerDelivery
        deliveries
        productDiscountRate
        planGiftId
        available
        featured
        type
    }
`